import React from 'react'
import { Helmet } from 'react-helmet'

const MetaData = props => {
  const { data } = props

  return (
    <Helmet>
      {
        [
          data.title && <title key="title">{data.title.text}</title>,
          data.description && <meta key="description" name="description" content={data.description.text} />,
          data.ogTitle && <meta key="ogTitle" property="og:title" content={data.ogTitle.text} />,
          data.ogDescription && <meta key="ogDescription" property="og:description" content={data.ogDescription.text} />,
          data.ogType && <meta key="ogType" property="og:type" content={data.ogType.text} />,
        ]
      }
      <script type="text/javascript">
        {`var whoistrack_params=whoistrack_params||[];whoistrack_params.push(["wait","d9867562d41a4499b25ef84080ffccb6"]);var t=document["createElement"]("script"),i;t["type"]="text/javascript";t["src"]=window["location"]["href"]["split"]("/")[0]+"//app.whoisvisiting.com/who.js";i=document["getElementsByTagName"]("script")[0];i["parentNode"]["insertBefore"](t,i);`}
      </script>
    </Helmet>
  )
}

export default MetaData



// WEBPACK FOOTER //
// ./src/components/metadata/index.js